// fetchFollowingTotalCount.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  MERGE_ME_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch following user total count
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchFollowingTotalCount = () => async (dispatch, getState) => {
  const selectPath = ['me', 'following'];
  const token = getMeData(getState(), 'token');

  const fetchOptions = {
    method: 'HEAD',
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const url = getResourceUrl({ endpoint: '/me/following' });

  dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
  try {
    let response = await fetch(url.href, fetchOptions);

    if (!response.ok) {
      response = await handleFetchError({
        response,
        dispatch,
        getState,
        fetchOptions,
        fetchUrl: url,
      });
    }

    const following = +response.headers.get('x-total-count');

    dispatch({ type: MERGE_ME_DATA, payload: { following } });
    return dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
  } catch (error) {
    return dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath, error },
    });
  }
};

export default fetchFollowingTotalCount;
